import {
  SimpleTable,
  SimpleTableRow,
  SimpleTableContainer,
  SimpleTableHeader,
  Loader ,
  Heading,
  DateRangePickerChips
} from 'cdk-radial';
import styled from 'styled-components';

export const StickySimpleTable: any = styled(SimpleTable)`
  position: relative;
  overflow: auto;
`;

export const StickySimpleTableContainer:any = styled(SimpleTableContainer)`
  max-width: '400px';
  overflow: auto;
  margin: '8px';
  min-height: '150px';
  height: '150px'
`;

export const StickySimpleTableHeader: any = styled(SimpleTableHeader)`
  position: sticky;
  text-align: ${props => props.textAlign};
  top: 0;
  z-index: 10;
`;

export const StickySimpleTableRow: any = styled(SimpleTableRow)`
  color: blue;
`;

export const StyledLoader : any = styled(Loader)`
    display: flex;
    margin-top: 10%;
`;

export const FullWidthTableData = styled.td`
  height: 10vh;
  width: 100%;
  text-align: center;
`;

export const StyledCenterDiv : any = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 10%;
`;


export const StyledMainContent = styled.div`
  align-items: stretch;
  display: flex;
  height: calc(100vh - 60px);
  justify-content: center;
  width: 100%;
`;

export const StyledPanelHeader = styled(Heading)`
  width: 100%;
  padding: 3% 1% 3% 3%;
  font-family: Roboto;
font-size: 16px;
font-weight: 600;
line-height: 26px;
text-align: left;
color:#FFFFFF;
                    

`;

export const StyledPanelHeaderContainer = styled.div`
  display: flex;
  background: #000000;  
   width: 100%;

`;

export const StyledSidePanelContainer = styled.div`
  
  alignitems: flex-end;
  flexdirection: column;
  flexgrow: 1;
`;

export const FocusWrapperIcon = styled.div`
  /* true if the wrapped Button has focus */
  &:has(:focus) {
    button {
      box-shadow: 0 0 0 4px rgb(0 0 0 / 50%);
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.15);
    }
  }
`;

export const StyledPanelButtonContainer = styled.div`
  padding: 2%;
  text-align: left;
  margin-top: 2%;
`;


